import { render, staticRenderFns } from "./uf_type_product_list.vue?vue&type=template&id=27857bfa&scoped=true"
import script from "./uf_type_product_list.vue?vue&type=script&lang=js"
export * from "./uf_type_product_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27857bfa",
  null
  
)

export default component.exports